import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { transient } from '@lichtblick/styled';
import { forwardRef } from 'react';
import { Destructive, IconWrapper, Label, Link, Primary, Secondary } from './LegacyButton.styles';
import { texts } from './LegacyButton.texts';
const variantMap = {
    primary: Primary,
    secondary: Secondary,
    destructive: Destructive,
    link: Link
};
/** @deprecated */ export const LegacyButton = /*#__PURE__*/ forwardRef(({ children, href, icon: Icon, isDisabled, isDownloadLink, isLoading, isSlim, isWide, renderAs, shouldOpenInNewTab, variant = 'primary', ...buttonProps }, ref)=>{
    const Variant = variantMap[variant];
    const as = href ? 'a' : renderAs;
    return /*#__PURE__*/ _jsxs(Variant, {
        as: as,
        disabled: isDisabled || isLoading,
        href: href,
        ref: ref,
        ...buttonProps,
        ...transient({
            isDownloadLink,
            isSlim,
            isWide,
            shouldOpenInNewTab
        }),
        children: [
            Icon && /*#__PURE__*/ _jsx(IconWrapper, {
                children: /*#__PURE__*/ _jsx(Icon, {})
            }),
            /*#__PURE__*/ _jsx(Label, {
                $isLoading: isLoading,
                children: isLoading ? texts.label.loading : children
            })
        ]
    });
});

//# sourceMappingURL=LegacyButton.js.map